import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaMoon, FaSun } from "react-icons/fa";
import { navigateToSection } from "../utils/hashSectionNav";
import { useTheme } from "../context/ThemeContext";

export const Navigation = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { theme, toggleTheme } = useTheme();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    let rafId = 0;

    const applyScrollState = () => {
      rafId = 0;
      const scrollTop = Math.max(
        window.scrollY || 0,
        window.pageYOffset || 0,
        document.documentElement?.scrollTop || 0,
        document.body?.scrollTop || 0
      );
      const scrolled = scrollTop > 8;
      setIsScrolled((prev) => (prev !== scrolled ? scrolled : prev));
      document.documentElement.classList.toggle("page-scrolled", scrolled);
    };

    const onScroll = () => {
      if (rafId) return;
      rafId = window.requestAnimationFrame(applyScrollState);
    };

    applyScrollState();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("touchmove", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    document.addEventListener("scroll", onScroll, true);

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("touchmove", onScroll);
      window.removeEventListener("resize", onScroll);
      document.removeEventListener("scroll", onScroll, true);
      if (rafId) window.cancelAnimationFrame(rafId);
      document.documentElement.classList.remove("page-scrolled");
    };
  }, [location.pathname, location.hash]);

  const logoSrc =
    theme === "dark"
      ? "/img/logo-rbb-dark.png?v=20260501-3"
      : "/img/logo-rbb.png?v=20260501-3";

  const goToSection = (e, sectionId) => {
    e.preventDefault();
    navigateToSection(navigate, location, sectionId);
  };

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
  };
  const urlRegister = props.data ? "https://app." + props.data.nameBankDomain + ".com.br/register" : "indefinido";
  const urlLogin = props.data ? "https://app." + props.data.nameBankDomain + ".com.br/login" : "indefinido";
  
  return (
    <nav
      id="menu"
      className={`navbar navbar-default navbar-fixed-top ${
        isScrolled ? "is-scrolled" : "is-at-top"
      }`}
    >
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="/">
            <img
              src={logoSrc}
              alt={props.data ? props.data.nameBank : "RBB Capital Investimentos"}
              className={`styled-logo ${
                theme === "dark" ? "styled-logo--dark-invert" : ""
              }`}
            />
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right ul-limited">
            <li>
              <a
                href="#about"
                className="page-scroll"
                onClick={(e) => goToSection(e, "about")}
              >
                Sobre nós
              </a>
            </li>
            <li>
              <a
                href="#services"
                className="page-scroll"
                onClick={(e) => goToSection(e, "services")}
              >
                Estratégia
              </a>
            </li>
            <li>
              <a
                href="#services"
                className="page-scroll"
                onClick={(e) => goToSection(e, "services")}
              >
                Conexão
              </a>
            </li>
            <li className="nav-cta-wrap">
              <div className="nav-cta">
                <button
                  type="button"
                  className="btn nav-cta-btn nav-cta-btn--ghost"
                  onClick={() => openInNewTab(urlLogin)}
                >
                  Acessar conta
                </button>
                <button
                  type="button"
                  className="btn nav-cta-btn nav-cta-btn--primary"
                  onClick={() => openInNewTab(urlRegister)}
                >
                  Abrir conta
                </button>
              </div>
            </li>
            <li className="nav-theme-toggle-wrap">
              <button
                type="button"
                className="nav-theme-toggle"
                onClick={toggleTheme}
                aria-label={
                  theme === "dark"
                    ? "Ativar tema claro"
                    : "Ativar tema escuro"
                }
                title={theme === "dark" ? "Tema claro" : "Tema escuro"}
              >
                {theme === "dark" ? <FaSun /> : <FaMoon />}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
